import { render, staticRenderFns } from "./NewOrderItem.vue?vue&type=template&id=35979de6&scoped=true&"
import script from "./NewOrderItem.vue?vue&type=script&lang=js&"
export * from "./NewOrderItem.vue?vue&type=script&lang=js&"
import style0 from "./NewOrderItem.vue?vue&type=style&index=0&id=35979de6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35979de6",
  null
  
)

export default component.exports